// extracted by mini-css-extract-plugin
module.exports = {"pageSummary":"jgp-TI8i7","cta":"jgp-1nUIi","container":"jgp-3lqgc","image":"jgp-1IRna","content":"jgp-2m777","slideUp":"jgp-Kkt6c","slideDown":"jgp-3tQQT"};